import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import useAccordion, { initialState } from './useAccordion';

const AccordionContext = createContext([initialState, {}]);

// eslint-disable-next-line react/prop-types
export const Provider = ({ defaultState, ...props }) => {
  const [state, fns] = useAccordion({ ...defaultState });

  return <AccordionContext.Provider {...props} value={[state, fns]} />;
};

const propTypes = { defaultState: PropTypes.oneOfType([PropTypes.object]) };

AccordionContext.propTypes = propTypes;
AccordionContext.defaultProps = { defaultState: {} };

export default AccordionContext;
